import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from "reactstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import Select from "react-select";

import ru from "date-fns/locale/ru";
import "react-datepicker/dist/react-datepicker.css";

import { CloseButton } from "components/CloseButton";
import { MySpinner } from "components/MySpinner";
import { getDocFromDiadoc } from "services/apiSupply";
import { dateFormatU, priceFormat } from "utils/format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";

import './getDocFromDiadoc.scss';

registerLocale("ru", ru);

const TIMES = [
  { label: '00:00 - 07:59', value: 1 },
  { label: '08:00 - 15:59', value: 2 },
  { label: '16:00 - 23:59', value: 3 },
]

export const GetDocFromDiadocModal = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [docsFromDiadoc, setDocsFromDiadoc] = useState([]);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [isShowReset, setIsShowReset] = useState(false);
  const [time, setTime] = useState(null);

  const getAndSetDocFromDiadoc = () => {
    setLoading(true);
    getDocFromDiadoc({
      dateStart: dateFormatU(dateStart),
      dateEnd: dateFormatU(dateEnd),
      time: time?.value
    })
      .then((res) => {
        setDocsFromDiadoc(res);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if (!openModal) return;
    getAndSetDocFromDiadoc();
  }, [openModal]);

  const searchHandler = () => {
    if (!isSearch()) return;
    getAndSetDocFromDiadoc();
  }

  const isSearch = () => {
    if (
      dateStart ||
      dateEnd
    ) {
      return true;
    }
    return false;
  };

  const resetFilter = () => {
    setDateStart("");
    setDateEnd("");
  };

  useEffect(() => {
    setIsShowReset(isSearch());
    if (!isSearch()) {
      getAndSetDocFromDiadoc();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dateStart,
    dateEnd
  ]);

  const tableColumns = [
    {
      dataField: "customer",
      text: "Поставщик",
      formatter: (cell, row) => row.provider?.name,
      headerStyle: () => {
        return { width: "30%" };
      },
    },
    {
      dataField: "document",
      text: "Документ",
      formatter: (cell, row) => <>№{row.number} от {row.date}</>,
      headerStyle: () => {
        return { width: "30%" };
      },
    },
    {
      dataField: "total",
      text: "Сумма",
      formatter: (cell, row) => <>{priceFormat(row.total)}</>,
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: (cell, row) => "right bold",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "createdAt",
      text: "Дата создания",
      headerStyle: () => {
        return { width: "20%" };
      },
    }
  ]

  const rowEvents = {
    onClick: (e, row) => {
      if (row.exist) return;
      history.push({
        pathname: "/receipt/supply/new",
        search: `?entityId=${row.entityId}&messageId=${row.messageId}`
      });
    },
  };

  const rowClasses = (row) => {
    if (row.exist) {
      return "exist";
    }
  }

  return (
    <>
      <Button onClick={() => setOpenModal(true)}>Загрузить из Диадок</Button>
      <Modal isOpen={openModal} toggle={() => setOpenModal(false)}>
        <ModalHeader>
          <div className="modal-title-text">Загрузить документ из Диадок</div>
          <CloseButton onClick={() => setOpenModal(false)} />
        </ModalHeader>

        {loading && <MySpinner overlay />}

        <ModalBody className="m-3">

          <Form className="mb-3">
            <Row>
              <Col>
                <InputGroup className="daterange">
                  <DatePicker
                    placeholderText="от"
                    selected={dateStart}
                    onChange={setDateStart}
                    selectsStart
                    startDate={dateStart}
                    endDate={dateEnd}
                    dateFormat="dd.MM.yyyy"
                    locale="ru"
                    className="form-control date-start"
                  />
                  <DatePicker
                    placeholderText="до"
                    selected={dateEnd}
                    onChange={setDateEnd}
                    selectsEnd
                    startDate={dateStart}
                    endDate={dateEnd}
                    minDate={dateStart}
                    dateFormat="dd.MM.yyyy"
                    locale="ru"
                    className="form-control date-end"
                  />
                  {dateStart && dateEnd &&
                    <Select
                      name="time"
                      placeholder="Диапазон времени"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      options={TIMES}
                      value={time}
                      onChange={setTime}
                      isClearable
                    />
                  }
                </InputGroup>

              </Col>
              <Col>
                <InputGroup>
                  {isShowReset && (
                    <Button color="danger" onClick={() => resetFilter()}>
                      <FontAwesomeIcon icon={faWindowClose} />
                    </Button>
                  )}
                  <Button
                    color="primary"
                    onClick={searchHandler}
                    className="button-wide"
                  >
                    Поиск
                  </Button>
                </InputGroup>
              </Col>
            </Row>

          </Form>
          <BootstrapTable
            wrapperClasses="docDiadoc p-0"
            keyField="id"
            data={docsFromDiadoc}
            columns={tableColumns}
            bootstrap4
            bordered={false}
            hover={true}
            rowEvents={rowEvents}
            classes="pointer"
            rowClasses={rowClasses}
          />


        </ModalBody>
      </Modal>
    </>
  );
};
